<template>
  <v-dialog v-model="dialog" width="650">
    <template v-slot:activator="{}">
      <BaseButton
        :text="
          localStorage.translations.pages['setting-users']['dialog-assign_role-buttons'][
            'naznachit-rol'
          ]
        "
        @click="openModal()"
      >
        <template v-slot:icon>
          <svg
            width="17"
            height="18"
            viewBox="0 0 17 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.81345 6.74384C6.74986 6.74384 7.56072 6.41155 8.22325 5.75594C8.88577 5.10044 9.22162 4.2984 9.22162 3.37181C9.22162 2.44555 8.88577 1.6434 8.22314 0.987682C7.5605 0.332289 6.74975 0 5.81345 0C4.87693 0 4.06629 0.332289 3.40376 0.987789C2.74123 1.64329 2.40527 2.44544 2.40527 3.37181C2.40527 4.2984 2.74123 5.10055 3.40387 5.75605C4.0665 6.41144 4.87725 6.74384 5.81345 6.74384Z"
              fill="#F2F2F2"
            />
            <path
              d="M10 14L12.25 17L16 11"
              stroke="#F2F2F2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M7.9357 14C7.93572 11.8886 9.58914 10.1593 11.6848 10.0104C11.6776 9.96747 11.6701 9.92419 11.6622 9.88059C11.6047 9.564 11.5308 9.26471 11.4423 8.99117C11.3508 8.70844 11.2265 8.42924 11.0727 8.16168C10.9132 7.88397 10.7258 7.64215 10.5155 7.44316C10.2956 7.23498 10.0263 7.06761 9.71497 6.94553C9.40471 6.82408 9.06087 6.76256 8.69306 6.76256C8.54861 6.76256 8.40892 6.8212 8.13914 6.99498C7.9731 7.10211 7.77889 7.22601 7.56211 7.36305C7.37675 7.4799 7.12565 7.58938 6.81549 7.6885C6.51289 7.78538 6.20564 7.83451 5.90239 7.83451C5.59915 7.83451 5.29201 7.78538 4.98909 7.6885C4.67925 7.58949 4.42814 7.48001 4.243 7.36316C4.02828 7.2274 3.83395 7.1035 3.66543 6.99487C3.39598 6.82109 3.25617 6.76245 3.11173 6.76245C2.74381 6.76245 2.40008 6.82408 2.08992 6.94563C1.77879 7.0675 1.50944 7.23488 1.28932 7.44326C1.07913 7.64236 0.89161 7.88407 0.732266 8.16168C0.578645 8.42924 0.454279 8.70834 0.362733 8.99128C0.274317 9.26482 0.200367 9.564 0.142934 9.88059C0.086041 10.1944 0.0473928 10.4921 0.0282845 10.7655C0.00950014 11.0334 0 11.3114 0 11.5922C0 12.323 0.234805 12.9147 0.697828 13.351C1.15513 13.7815 1.76022 14 2.49605 14H7.9357Z"
              fill="#F2F2F2"
            />
          </svg>
        </template>
      </BaseButton>
    </template>
    <transition :duration="150">
      <UserAssingRolesModalList
        v-if="dialog"
        :closeModal="closeModal"
        :subscriber="subscriber"
        :onDownloadPageData="onDownloadPageData"
      />
    </transition>
  </v-dialog>
</template>

<script>
import UserAssingRolesModalList from 'components/setting/users/UserAssingRolesModalList'
export default {
  name: 'UserAssingRolesModal',
  props: { subscriber: Boolean, onDownloadPageData: Function },
  components: { UserAssingRolesModalList },
  data() {
    return {
      dialog: false,
    }
  },
  methods: {
    openModal() {
      this.dialog = true
    },
    closeModal() {
      this.dialog = false
    },
  },
}
</script>

<style lang="scss" scoped></style>
